// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table.b-table > tbody > .table-active,\n.table.b-table > tbody > .table-active > th,\n.table.b-table > tbody > .table-active > td {\n  background-color: #1a6a72;\n  color: #ffffff;\n}\n.b-table-sticky-header > .table.b-table > thead > tr > th {\n  border-top: 0;\n}\n.table thead th {\n  font-size: 12px;\n}", ""]);
// Exports
module.exports = exports;
